import { render, staticRenderFns } from "./ShelfDepthPicker.vue?vue&type=template&id=3dd4ade2&scoped=true"
import script from "./ShelfDepthPicker.vue?vue&type=script&lang=js"
export * from "./ShelfDepthPicker.vue?vue&type=script&lang=js"
import style0 from "./ShelfDepthPicker.vue?vue&type=style&index=0&id=3dd4ade2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd4ade2",
  null
  
)

export default component.exports